import React, { Component } from 'react';

class DropdownChildren extends Component {
  componentDidMount() {
    document.addEventListener('click', this.props.closeOptions);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.props.closeOptions);
  }

  render() {
    const { children, ...props } = this.props;
    return <div className="contact-optionBox">{children}</div>;
  }
}

export default DropdownChildren;



// WEBPACK FOOTER //
// ./src/components/NewContact/DropdownChildren.js